import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

import LawsInside from "./LawsInside.js";

const content = (
     <span>
          ماده ۱- اصل بر صحت و اصالت معاملات تجاری موضوع ماده(۲) قانون تجارت است، مگر آن‌که براساس مفاد این قانون خلاف آن به اثبات برسد. استیلای اشخاص براموال و دارایی اگر توأم با ادعای مالکیت شود، دال بر ملکیت است.
          <br/>
          ماده ۲ - جرم پولشویی عبارت است از:
          <br />
          الف - تحصیل، تملک، نگهداری یا استفاده از عواید حاصل از فعالیت‌های غیرقانونی با علم به این که به طور مستقیم یا غیرمستقیم در نتیجه ارتکاب جرم به دست آمده باشد .
          <br />
          ب -تبدیل، مبادله یا انتقال عوایدی به منظور پنهان‌کردن منشأ غیرقانونی آن با علم به این که به‌طور مستقیم یا غیرمستقیم ناشی از ارتکاب جرم بوده یا کمک به مرتکب به نحوی که وی مشمول آثار و تبعات قانونی ارتکاب آن جرم نگردد .
          <br />
          ج - اخفاء یا پنهان یا کتمان‌کردن ماهیت واقعی، منشأ، منبع، محل، نقل و انتقال، جابه‌جایی یا مالکیت عوایدی که به‌طور مستقیم یا غیرمستقیم در نتیجه جرم تحصیل‌شده باشد .
          <br />
          ماده۳ - عواید حاصل از جرم به معنای هر نوع مالی است که به‌طور مستقیم یا غیرمستقیم از فعالیتهای مجرمانه به دست آمده‌باشد .
          <br />
          ماده۴ - منظور هماهنگ کردن دستگاههای ذی‌ربط در امر جمع‌آوری، پردازش و تحلیل اخبار، اسناد و مدارک، اطلاعات و گزارشهای واصله، تهیه سیستمهای اطلاعاتی هوشمند، شناسایی معاملات مشکوک و به منظور مقابله با جرم پولشویی شورای عالی مبارزه با پولشویی به ریاست و مسؤولیت وزیر امور اقتصادی و دارایی و با عضویت وزراء بازرگانی، اطلاعات، کشور و رئیس بانک مرکزی با وظایف ذیل تشکیل می‌گردد :
          <br />
          ۱- جمع‌آوری و کسب اخبار و اطلاعات مرتبط وتجزیه وتحلیل وطبقه‌بندی فنی وتخصصی آنها در مواردی که قرینه‌ای بر تخلف وجود دارد طبق مقررات .
          <br />
          ۲- تهیه و پیشنهاد آئین‌نامه‌های‌لازم درخصوص اجراء قانون به هیأت وزیران .
          <br />
          ۳- هماهنگ‌کردن دستگاههای ذی‌ربط و پیگیری اجراء کامل قانون در کشور .
          <br />
          ۴- ارزیابی گزارشهای دریافتی و ارسال به قوه قضائیه در مواردی که‌به احتمال قوی صحت دارد و یا محتمل آن از اهمیت برخوردار است .
          <br />
          ۵- تبادل تجارب واطلاعات با سازمانهای مشابه درسایرکشورها درچهارچوب مفاد ماده(۱۱).
          <br />
          تبصره ۱ - دبیرخانه شورای‌عالی دروزارت اموراقتصادی و دارایی خواهدبود .
          <br />
          تبصره ۲ - ساختار و تشکیلات اجرائی شورا متناسب با وظایف قانونی آن‌با پیشنهاد شورا به تصویب هیأت وزیران خواهد رسید .
          <br />
          تبصره ۳ - کلیه آئین‌نامه‌های اجرائی شورای فوق‌الذکر پس از تصویب هیأت وزیران برای تمامی اشخاص حقیقی و حقوقی ذی‌ربط لازم‌الاجراء خواهد بود. متخلف از این امر به تشخیص مراجع اداری و قضائی حسب‌مورد به دو تا پنج‌سال انفصال ازخدمت‌مربوط محکوم خواهد شد .
          <br />
          ماده ۵ - کلیه اشخاص حقوقی از جمله بانک مرکزی جمهوری اسلامی ایران، بانکها، مؤسسات مالی و اعتباری، بیمه‌ها، بیمه مرکزی، صندوقهای قرض‌الحسنه، بنیادها و مؤسسات خیریه و شهرداریها مکلفند آئین نامه‌های مصوب هیأت وزیران در اجراء این قانون را به مورد اجراء گذارند .
          <br />
          ماده ۶ - دفاتر اسناد رسمی، وکلای دادگستری، حسابرسان، حسابداران، کارشناسان رسمی دادگستری و بازرسان قانونی مکلفند اطلاعات مورد نیاز در اجراء این قانون را که هیأت وزیران مصوب می‌کند، حسب درخواست شورای عالی مبارزه با پولشویی، ارائه نمایند .
          <br />
          ماده ۷ - اشخاص، نهادها و دستگاههای مشمول این قانون ( موضوع مواد ۵ و ۶) ‌برحسب نوع فعالیت و ساختار سازمانی خود مکلف به رعایت موارد زیر هستند :
          <br />
          الف - احراز هویت ارباب رجوع و در صورت اقدام توسط نماینده یا وکیل، احراز سمت و هویت نماینده و وکیل و اصیل در مواردی که قرینه‌ای بر تخلف وجود دارد .
          <br />
          تبصره - تصویب این قانون ناقض مواردی که در سایر قوانین و مقررات احراز هویت الزامی شده است، نمی‌باشد .
          <br />
          ب - ارائه اطلاعات، گزارشها، اسناد و مدارک مربوط به موضوع این قانون به شورای عالی مبارزه با پولشویی در چهارچوب آئین‌نامه مصوب هیأت وزیران .
          <br />
          ج - گزارش معاملات و عملیات مشکوک به مرجع ذی‌صلاحی که شورای عالی مبارزه با پولشویی تعیین می‌کند .
          <br />
          د - نگهداری سوابق مربوط به شناسایی ارباب رجوع، سوابق حسابها، عملیات و معاملات به مدتی که در آئین‌نامه اجرائی تعیین می‌شود .
          <br />
          هـ ‌تدوین معیارهای کنترل داخلی و آموزش مدیران و کارکنان به منظور رعایت مفاد این قانون و آئین‌نامه‌های اجرائی آن .
          <br />
          ماده ۸ - اطلاعات و اسناد گردآوری شده در اجراء این قانون،‌صرفاً در جهت اهداف تعیین‌شده در قانون مبارزه با پولشویی و جرائم منشأ آن مورد استفاده قرار خواهدگرفت، افشاء اطلاعات یا استفاده از آن به نفع خود یا دیگری به‌طور مستقیم یا غیرمستقیم توسط مأموران دولتی یا سایر اشخاص مقرر در این قانون ممنوع بوده و متخلف به مجازات مندرج در قانون مجازات انتشار و افشاء اسناد محرمانه و سری دولتی مصوب ۲۹/۱۱/۱۳۵۳، محکوم خواهدشد .
          <br />
          ماده ۹ - مرتکبین جرم پولشویی علاوه بر استرداد درآمد و عواید حاصل از ارتکاب جرم مشتمل بر اصل و منافع حاصل (و اگر موجود نباشد، مثل یا قیمت آن) به جزای نقدی به میزان یک چهارم عواید حاصل از جرم محکوم می‌شوند که باید به حساب درآمد عمومی نزد بانک مرکزی جمهوری اسلامی ایران واریز گردد .
          <br />
          تبصره ۱ - چنانچه عواید حاصل به اموال دیگری تبدیل یا تغییر یافته‌باشد، همان اموال ضبط خواهدشد .
          <br />
          تبصره ۲ - صدور و اجراء حکم ضبط دارایی و منافع حاصل از آن در صورتی است که متهم به لحاظ جرم منشأ، مشمول این حکم قرار نگرفته ‌باشد .
          <br />
          تبصره ۳ - مرتکبین جرم منشأ، در صورت ارتکاب جرم پولشویی، علاوه بر مجازاتهای مقرر مربوط به جرم ارتکابی، به مجازاتهای پیش‌بینی شده در این قانون نیز محکوم خواهندشد .
          <br />
          ماده ۱۰ - کلیه اموری که در اجراء این قانون نیاز به اقدام یا مجوز قضائی دارد باید طبق مقررات انجام پذیرد. قوه قضائیه موظف است طبق مقررات همکاری نماید .
          <br />
          ماده ۱۱ - شعبی از دادگاههای عمومی در تهران و در صورت نیاز در مراکز استانها به امر رسیدگی به جرم پولشویی و جرائم مرتبط اختصاص می‌یابد. اختصاصی بودن شعبه مانع رسیدگی به سایر جرائم نمی‌باشد .
          <br />
          ماده ۱۲ - در مواردی که بین دولت جمهوری اسلامی ایران و سایر کشورها قانون معاضدت قضایی و اطلاعاتی در امر مبارزه با پولشویی تصویب شده باشد، همکاری طبق شرایط مندرج در توافقنامه صورت خواهدگرفت .
          <br />
          قانون فوق مشتمل بر دوازده ماده و هفت تبصره در جلسه علنی روز سه‌شنبه مورخ دوم بهمن‌ماه یکهزار و سیصد و هشتاد و شش مجلس شورای اسلامی تصویب و در تاریخ ۱۷/۱۱/۱۳۸۶ به تأیید شورای نگهبان رسید .
          <br />
          غلامعلی حدادعادل-رئیس مجلس شورای اسلامی
     </span>
);
const GeneralOneInside = props => {
     return props.size === "laptopdesktop" ? (
          <div>
               <LawsInside title="قانون مبارزه با پولشويی" text={content} size="laptopdesktop"/>
          </div>
     ) : props.size === "tablet" ? (
          <div>
               <LawsInside title="قانون مبارزه با پولشويی" text={content} size="tablet" />
          </div>

     ) : (
          <div>
               <LawsInside title="قانون مبارزه با پولشويی" text={content} />
          </div>
     );
};

export default GeneralOneInside;
